<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="ppeApplyScrapResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" exportDisabled checkboxColumnDisabled editDisable
                                      with-custom-row-actions-first-column>
                                <!--                                <template slot="customRowActions" slot-scope="customRowScope">-->
                                <!--                                    <b-button-group>-->
                                <!--                                        <em-button type="task"-->
                                <!--                                                   v-bind:class="'btn btn-outline-primary btn-sm'"-->
                                <!--                                                   @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">-->
                                <!--                                        </em-button>-->
                                <!--                                    </b-button-group>-->
                                <!--                                </template>-->
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <em-button type="task"
                                               :busy="claimLoading"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :custom-label="isClaim ? '认领任务' : '处理任务'"
                                               @click="handleExecute(customRowScope.row)">
                                    </em-button>
                                    <em-button type="gotoChild"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               custom-icon="fa fa-fw fa-lg fa-th-list"
                                               custom-label="申请报废的PPE物品"
                                               @click="selectMaterials(customRowScope.row)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <sub-entity-list ref="ppeMaterialsEntityList" sub-entity="ppeApplyScrapDetail"
                         parent-field="flowId" size="xl"></sub-entity-list>
    </div>
</template>
<script>
// Author THQ
// Date 2025-04-08 13:29:31
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import ClaimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";
import subEntityList from "@/components/em/EmModal/SubEntityList/index.vue";

export default {
    name: "ppeApplyScrapWorkflowListView",
    components: {subEntityList},
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, ClaimTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        selectMaterials(row) {
            this.$refs.ppeMaterialsEntityList.showModal(row.id);
        }
    }
};
</script>